__turbopack_context__.v({
  "badge": "gezdnq_badge",
  "hidden": "gezdnq_hidden",
  "star": "gezdnq_star",
  "value": "gezdnq_value",
});
